import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const undesiredSeverityRoutes = [
  {
    path: "/directories/undesired-severity",
    name: "UndesiredSeverityList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "undesiredSeverity" */ "./components/List"),
  },
];
